var React = require('react');

function Smicon (props) {
    return React.createElement("svg",props,React.createElement("rect",{"x":"3.99951","y":"24","width":"28.2846","height":"28.2846","transform":"rotate(-45 3.99951 24)","fill":"#E8EFFF"}));
}

Smicon.defaultProps = {"width":"48","height":"48","viewBox":"0 0 48 48","fill":"none"};

module.exports = Smicon;

Smicon.default = Smicon;
